import React, { useEffect, useState, useMemo } from "react";
import { Header } from "../components/Common/Header";
import { Link, useNavigate } from "react-router-dom";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/thumbnail/lib/styles/index.css";

import { PrimaryButton } from "../components/Common/PrimaryButton";

import HomeImage from "../assets/images/Headers/Ebooks.webp";


export const Ebooks = () => {

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ebooks = useMemo(() => [
    {
      title: "Coaching for Enhanced Social Impact",
      fileUrl: "/assets/ebooks/guide.pdf",
      imageUrl: "/assets/images/Ebooks/guide.png",
    },
    {
      title: "Coaching for Enhanced Social Impact",
      fileUrl: "/assets/ebooks/coaching-for-enhanced-social-impact.pdf",
      imageUrl: "/assets/images/Ebooks/coaching-for-enhanced-social-impact.jpg",
    },
    {
      title: "Elements of Career Success",
      fileUrl: "/assets/ebooks/elements-of-career-success.pdf",
      imageUrl: "/assets/images/Ebooks/elements-of-career-success.jpg",
    },
    {
      title: "Interpersonal Effectiveness in Coaching",
      fileUrl: "/assets/ebooks/interpersonal-effectiveness-in-coaching.pdf",
      imageUrl: "/assets/images/Ebooks/interpersonal-effectiveness-in-coaching.jpg",
    },
    {
      title: "So, You Want to Be a Coach",
      fileUrl: "/assets/ebooks/so-you-want-to-be-a-coach.pdf",
      imageUrl: "/assets/images/Ebooks/so-you-want-to-be-a-coach.jpg",
    },
  ], []);

  const [images, setImages] = useState([]);

  const handleDownload = async (fileUrl) => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
  
      try {
        const params = new URLSearchParams();
        params.append("name", userData.name);
        params.append("email", userData.email);
        params.append("phone", userData.phone);
  
        await fetch(
          "https://script.google.com/macros/s/AKfycbwU2kZ2MQKCkRrl4w9dTuAg-TcAVNOr_-N6HMbmyvlb-aC4EyaH7NibZAYUhy9wh3OM/exec",
          {
            method: "POST",
            body: params,
          }
        );
  
        // Optional: trigger download after submission
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileUrl.split("/").pop();
        link.click();
      } catch (error) {
        console.error("Error sending data:", error);
      }
    } else {
      navigate("/forms");
    }
  };
  

  useEffect(() => {
    const loadImages = () => {
      const imageUrls = ebooks.map((ebook) => {
        return { title: ebook.title, imageUrl: ebook.imageUrl, fileUrl: ebook.fileUrl };
      });
      setImages(imageUrls);
    };
    loadImages();
  }, [ebooks]);

  return (
    <>
      <Header
        image={HomeImage}
        title="Our Ebooks"
      />
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        {images.map((ebook, index) => (
          <div style={{display: "flex", flexDirection: "column", justifyContent:"center", alignItems: "center", gap: 10}}>
          <div
            key={index}
            style={{
              borderRadius: "8px",
              width: "350px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <Link
              to={`/pdf-viewer?file=${encodeURIComponent(ebook.fileUrl)}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={ebook.imageUrl}
                alt={ebook.title}
                style={{
                  width: "100%",
                  height: "auto",
                  marginBottom: "10px",
                  objectFit: "cover",
                }}
              />
            </Link>
          </div>
          <PrimaryButton
            label="Download"
            onClick={() => handleDownload(ebook.fileUrl)}
            style={{
              width: "80%",
            }} />
          </div>
        ))}
      </div>
    </>
  );
};
